import {
  selectConsultationAllowanceParams,
  selectConsultationCreatingConsultation,
  selectConsultationCurrentConsultation,
  selectConsultationLastConsultation,
  selectConsultationPatient,
} from '@app/store/consultation/consultation.selectors';
import { Injectable } from '@angular/core';
import { resetConsultationData, setConsultationPetOwner } from '@app/store/consultation/consultation.actions';
import { Store } from '@ngrx/store';
import { AppState } from '..';
import { PetOwner } from '@app/core/models';

@Injectable()
export class ConsultationFacade {
  consultationAllowanceParams$ = this.store$.select(selectConsultationAllowanceParams);
  consultationCreatingConsultation$ = this.store$.select(selectConsultationCreatingConsultation);
  consultationPatient$ = this.store$.select(selectConsultationPatient);
  lastConsultation$ = this.store$.select(selectConsultationLastConsultation);
  currentConsultation$ = this.store$.select(selectConsultationCurrentConsultation);

  constructor(private store$: Store<AppState>) {}

  resetConsultationData(): void {
    this.store$.dispatch(resetConsultationData());
  }

  setConsultationPetOwner(value: PetOwner): void {
    this.store$.dispatch(setConsultationPetOwner({ value }));
  }
}
